import styled, { css } from 'styled-components';
import {
  Container as GridContainer
} from 'components/Grid';

export const Section = styled.section`
  background-color: #ff441f;
`;

export const Container = styled(GridContainer)`
  height: 480px;
`;

const text = css`
  text-align: center;
  color: #fff;
`;

export const Text = styled.h2`
  ${text}
  max-width: 774px;
`;

Text.xs = styled.h4`
  ${text}
  max-width: 328px;
`;
